import React from "react";
import MainNewsItemOne from "./MainNewsItemOne";
import NewsFirstCol from "./NewsFirstCol";
import NewsSecondCol from "./NewsSecondCol";

const MainNews = () => {
  return (
    <div className="home-banner container">
      <div className="row d-flex">
        <MainNewsItemOne />
        <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12">
          <NewsFirstCol />
        </div>
        <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12">
          <NewsSecondCol />
        </div>
      </div>
    </div>
  );
};

export default MainNews;
